module.exports = __webpack_public_path__ + "images/jumpstart-blog-banner.jpg";